import {
  Flex,
  Image,
  Container,
  Input,
  InputGroup,
  InputRightElement,
  Button,
  InputLeftElement,
  Text,
  Box,
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  HStack,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuGroup,
  MenuDivider,
  IconButton,
  Avatar,
  Badge,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Stack
} from "@chakra-ui/react";
import React from "react";
import { BsSearch, BsBell,BsBellSlash } from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";
import JoinPopup from "./JoinPopup";
import SignInPopup from "./SignInPopup";
import { MdMailOutline } from "react-icons/md";
import { AiOutlineHeart,AiOutlineLeft,AiOutlineRight } from "react-icons/ai";
import CommonHeaderCategory from "./HeaderCategory";
import CommonContainer from "./shared/CommonContainer";
import { CgMenuRight } from "react-icons/cg";

export default function Header({ freelancer }) {
  const [popup,setPopup] = React.useState("");
  const location = useLocation();
  const pathName = location.pathname;
  const message = pathName.includes("message") || pathName.includes("gig/create");
  const createGigPage = pathName.includes("gig/create");
  return (
    <Box
      as="header"
      borderBottom={{ base: "1px", "2xl": "0px" }}
      borderColor={"#ebebeb"}
    >
      <Container px={{ md: 10 }} maxW="90vw" py={4}>
        <Flex justifyContent={"space-between"}>
          <Flex align="center" gap={8}>
            <Link to="/">
              <Image src="/logo.png" width="128px" />
            </Link>
            <InputGroup size="sm" display={{ base: "none", xl: "block" }}>
              <InputLeftElement>
                <BsSearch />
              </InputLeftElement>
              <Input
                placeholder="Find Services"
                w={{ "2xl": "600px" }}
                borderRadius={5}
              />
              <InputRightElement width="5rem">
                <Button
                  height="2rem"
                  colorScheme={"brand"}
                  borderLeftRadius={0}
                >
                  Search
                </Button>
              </InputRightElement>
            </InputGroup>
          </Flex>
          {freelancer ? (
            <Flex
              align="center"
              color="#707070"
              gap={6}
              display={{ base: "none", md: "flex" }}
            >
              {freelancerLinkList.map((item) => (
                <Link to={item.href} key={item.name}>
                  <Text>{item.name}</Text>
                </Link>
              ))}
              {/* <Popover>
                <PopoverTrigger>
                  <Text cursor="pointer">Order</Text>
                </PopoverTrigger>
                <PopoverContent>
                  <PopoverArrow />

                  <PopoverBody>
                    <Stack p={5} gap={2} alignItems="center">
                      <Box p={2} rounded="full" bg="#eee" color="#888">
                        <AiOutlineInbox size="40px" />
                      </Box>
                      <Text
                        fontSize={"17px"}
                        align="center"
                        color="#727272"
                        fontWeight="semibold"
                      >
                        No Order Yet
                      </Text>
                      <Text
                        fontSize={"14px"}
                        align="center"
                        color="#c5c5c5"
                        fontWeight="medium"
                      >
                        Use the Search box find the digital services you need.
                      </Text>
                    </Stack>
                  </PopoverBody>
                </PopoverContent>
              </Popover> */}
              <Flex ml={2}>
                <Popover >
                  <PopoverTrigger>
                    <IconButton variant="unstyled" fontSize="20px">
                      <BsBell />
                    </IconButton>
                  </PopoverTrigger>
                  <PopoverContent width="240px">
                    <PopoverArrow />

                    <PopoverBody>
                      <Stack p={3} gap={1} alignItems="center">
                        <Box p={4} rounded="full" bg="#eee" color="#888">
                          <BsBellSlash size="24px" />
                        </Box>
                        <Text
                          fontSize={"16px"}
                          align="center"
                          color="#727272"
                          fontWeight="semibold"
                        >
                          No Notification
                        </Text>
                        <Text
                          fontSize={"12px"}
                          align="center"
                          color="#c5c5c5"
                          fontWeight="medium"
                        >
                          Browse our amazing catalog of Gigs and Proposal or offers on Decolance
                        </Text>
                      </Stack>
                    </PopoverBody>
                  </PopoverContent>
                </Popover>

                <IconButton variant="unstyled" fontSize="20px">
                  <MdMailOutline />
                </IconButton>
                <IconButton variant="unstyled" fontSize="20px">
                  <AiOutlineHeart />
                </IconButton>
              </Flex>
              {/* Profile of avatar menu */}
              <Menu>
                <MenuButton>
                  <Avatar
                    src="/images/freelancer/profiles/1.png"
                    alignItems="start"
                  >
                    <Box
                      as="span"
                      pos="relative"
                      left="-10px"
                      p="4px"
                      fontSize="xs"
                      fontWeight="bold"
                      lineHeight="none"
                      color="green.100"
                      // transform="translate(50%,-50%)"
                      bg="#00D900"
                      rounded="full"
                    />
                  </Avatar>
                </MenuButton>
                <MenuList>
                  <MenuGroup>
                    <MenuItem>Profile</MenuItem>
                    <MenuItem>Manage Requests</MenuItem>
                    <MenuItem>Post a Request</MenuItem>
                  </MenuGroup>
                  <MenuDivider />
                  <MenuGroup>
                    <MenuItem>Settings</MenuItem>
                    <MenuItem>
                      Billing{" "}
                      <Badge
                        bg="#FFBE5B"
                        rounded="2xl"
                        color="white"
                        px={3}
                        py={"4px"}
                        fontSize="14px"
                        mx={2}
                      >
                        New
                      </Badge>
                    </MenuItem>
                  </MenuGroup>
                  <MenuDivider />
                  <MenuGroup>
                    <MenuItem>English</MenuItem>
                    <MenuItem>PKR</MenuItem>
                    <MenuItem>Help & Support</MenuItem>
                  </MenuGroup>
                  <MenuDivider />
                  <MenuGroup>
                    <MenuItem>Logout</MenuItem>
                  </MenuGroup>
                </MenuList>
              </Menu>
            </Flex>
          ) : (
            <Flex
              align="center"
              gap={{ base: 4, xl: 10 }}
              display={{ base: "none", md: "flex" }}
            >
              {linkList.map((item) => (
                <Link to={item.href} key={item.name}>
                  <Text color="gray">{item.name}</Text>
                </Link>
              ))}
              <SignInPopup view={popup==="sign"} setView={setPopup} />
              <JoinPopup view={popup==="join"} setView={setPopup} />
            </Flex>
          )}
          <Flex
            alignItems="center"
            color="#c5c5c5"
            display={{ base: "flex", md: "none" }}
          >
            <HeaderMobileSidebar freelancer={freelancer} pathName={pathName} />
          </Flex>
        </Flex>
      </Container>
      {freelancer && !createGigPage && (
        <Flex display={{ base: "none", md: "flex" }} bg="#f4f4f4">
          <CommonContainer>
            <Flex>
              {freelancerLinksData.map((item) => {
                return (
                  <FreelancerLinkBtn
                    key={item.name}
                    label={item.name}
                    href={item.href}
                    active={pathName.includes(item.href)}
                  />
                );
              })}
            </Flex>
          </CommonContainer>
        </Flex>
      )}
      {/* It should not display on message page */}
      {freelancer && !message && (
        <Flex
          borderTop="2px"
          display={{ base: "none", md: "block" }}
          borderBottom="1px"
          py={1}
          borderColor={"#ebebeb"}
        >
          <CommonContainer>
            <Flex justifyContent="space-between" py={2} overflowX={"hidden"}  id="header-category-container">
              {categoriesData.map((item) => {
                return (
                  <CommonHeaderCategory
                    key={item.name}
                    name={item.name}
                    structured={item.structured}
                    linksList={item.linksList}
                  />
                );
              })}
              <Box pos="absolute" p={1} left={10}  height="fill"  bg="white" cursor="pointer"  onClick={(e)=>{document.querySelector("#header-category-container").scrollBy({left:-150,behavior:"smooth"})}} zIndex={1}>
          <AiOutlineLeft />
        </Box>
        <Box pos="absolute" right={10} p={1} height="fill" cursor="pointer"   bg="white"  onClick={()=>{document.querySelector("#header-category-container").scrollBy({left:150,behavior:"smooth"})}} zIndex={1}>
          <AiOutlineRight />
        </Box>
            </Flex>
          </CommonContainer>
        </Flex>
      )}
    </Box>
  );
}
const FreelancerLinkBtn = ({ active, label, href }) => {
  return (
    <Link to={"/freelancer" + href}>
      <Text
        bg={active && "brand.500"}
        color={active ? "white" : "#000000AB"}
        px={{ base: 2, md: 3, "2xl": 8 }}
        py={4}
        fontSize={{ base: "10px", md: "10px", lg: "15px", "2xl": "18px" }}
        fontWeight="semibold"
      >
        {label}
      </Text>
    </Link>
  );
};

const HeaderMobileSidebar = ({ freelancer, pathName }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <IconButton variant="unstyled" cursor="pointer" onClick={onOpen}>
        <CgMenuRight size="30px" />
      </IconButton>
      <Drawer isOpen={isOpen} onClose={onClose} placement="left" size="xs">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerBody py={10}>
            <Flex
              alignItems="start"
              gap={{ base: 4, xl: 10 }}
              flexDirection={"column-reverse"}
            >
              {linkList.map((item) => (
                <Link to={item.href} key={item.name}>
                  <Text color="gray">{item.name}</Text>
                </Link>
              ))}
              <HStack>
                <JoinPopup />
                <SignInPopup />
              </HStack>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

const linkList = [
  {
    name: "Find Work",
    href: "find-work",
  },
  {
    name: "Gigs",
    href: "marketplace",
  },
  {
    name: "Become a Seller",
    href: "become-seller",
  },
];
const freelancerLinkList = [
  {
    name: "Post a Job",
    href: "/job/post",
  },
  {
    name: "Find Work",
    href: "/find-work",
  },
];
const freelancerLinksData = [
  {
    name: "Dashboard",
    href: "/dashboard",
  },
  {
    name: "Messages",
    href: "/messages",
  },
  {
    name: "Orders",
    href: "/order",
  },
  {
    name: "Gigs",
    href: "/gigs",
  },
  {
    name: "Analytics",
    href: "/analytics",
  },
  {
    name: "Earnings",
    href: "/earnings",
  },
  {
    name: "Active Order",
    href: "/active-order",
  },
  {
    name: "Buy Bid Token",
    href: "/connects",
  },
];
const categoriesData = [
  {
    name: "Graphics & Design",
    structured: true, //Structured data would contain title with links whereas non structured would not contain any title with links. Both rendering would be different based on true or false
    linksList: [
      [
        {
          title: "Logo & Brand Identity",
          list: [
            {
              label: "Logo Design",
              href: "#",
            },
            {
              label: "Brand Style Guides",
              href: "#",
            },
            {
              label: "Fonts & Typography",
              href: "#",
            },
            {
              label: "Business Cards & Stationery",
              href: "#",
            },
          ],
        },
        {
          title: "Gaming",
          list: [
            {
              label: "Game Art",
              href: "#",
            },
            {
              label: "Graphics for Streamers",
              href: "#",
            },
            {
              label: "Twitch Store",
              href: "#",
            },
          ],
        },
        {
          title: "Art & Illustration",
          list: [
            {
              label: "Illustration",
              href: "#",
            },
            {
              label: "NFT Art",
              href: "#",
            },
            {
              label: "Pattern Design",
              href: "#",
            },
            {
              label: "Portraits & Caricatures",
              href: "#",
            },
            {
              label: "Cartoons & Comics",
              href: "#",
            },
            {
              label: "Tattoo Design",
              href: "#",
            },
            {
              label: "Storyboards",
              href: "#",
            },
          ],
        },
      ],
      [
        {
          title: "Web & App Design",
          list: [
            {
              label: "Website Design",
              href: "#",
            },
            {
              label: "App Design",
              href: "#",
            },
            {
              label: "UX Design",
              href: "#",
            },
            {
              label: "Landing Page Design",
              href: "#",
            },
            {
              label: "Icon Design",
              href: "#",
            },
          ],
        },
        {
          title: "Marketing Design",
          list: [
            {
              label: "Social Media Design",
              href: "#",
            },
            {
              label: "Email Design",
              href: "#",
            },
            {
              label: "Web Banners",
              href: "#",
            },
            {
              label: "Signage Design",
              href: "#",
            },
          ],
        },
        {
          title: "Packaging & Covers",
          list: [
            {
              label: "Packaging & Label Design",
              href: "#",
            },
            {
              label: "Book Design",
              href: "#",
            },
            {
              label: "Album Cover Design",
              href: "#",
            },
            {
              label: "Podcast Cover Art",
              href: "#",
            },
          ],
        },
      ],
      [
        {
          title: "Visual Design",
          list: [
            {
              label: "Image Editing",
              href: "#",
            },
            {
              label: "Presentation Design",
              href: "#",
            },
            {
              label: "Infographic Design",
              href: "#",
            },
            {
              label: "Vector Tracing",
              href: "#",
            },
            {
              label: "Resume Design",
              href: "#",
            },
          ],
        },
        {
          title: "Architecture & Design",
          list: [
            {
              label: "Architecture & Interior Design",
              href: "#",
            },
            {
              label: "Landscape Design",
              href: "#",
            },
            {
              label: "Building Engineering",
              href: "#",
            },
            {
              label: "Building Information",
              href: "#",
            },
          ],
        },
        {
          title: "Fashion & Jewelry",
          list: [
            {
              label: "Fashion Design",
              href: "#",
            },
            {
              label: "Jewelry Design",
              href: "#",
            },
          ],
        },
      ],
      [
        {
          title: "Print Design",
          list: [
            {
              label: "T-Shirts & Merchandise",
              href: "#",
            },
            {
              label: "Flyer Design",
              href: "#",
            },
            {
              label: "Brochure Design",
              href: "#",
            },
            {
              label: "Poster Design",
              href: "#",
            },
            {
              label: "Catalog Design",
              href: "#",
            },
          ],
        },
        {
          title: "Product & Characters Design",
          list: [
            {
              label: "Industrial & Product Design",
              href: "#",
            },
            {
              label: "Character Modeling",
              href: "#",
            },
            {
              label: "Trade Booth Design",
              href: "#",
            },
          ],
        },
        {
          title: "Miscellaneous",
          list: [
            {
              label: "Logo Maker Tool",
              href: "#",
            },
            {
              label: "Design Advice",
              href: "#",
            },
            {
              label: "Other",
              href: "#",
            },
          ],
        },
      ],
    ],
  },
  {
    name: "Digital Marketing",
    structured: false,
    linksList: [
      [
        {
          label: "Social Media Marketing",
          href: "#",
        },
        {
          label: "Social Media Advertising",
          href: "#",
        },
        {
          label: "Search Engine Optimization (SEO)",
          href: "#",
        },
        {
          label: "Local SEO",
          href: "#",
        },
        {
          label: "Marketing Strategy",
          href: "#",
        },
        {
          label: "Public Relations",
          href: "#",
        },
        {
          label: "Guest Posting",
          href: "#",
        },
        {
          label: "Video Marketing",
          href: "#",
        },
        {
          label: "Email Marketing",
          href: "#",
        },
        {
          label: "Web Analytics",
          href: "#",
        },
        {
          label: "Text Message Marketing",
          href: "#",
        },
        {
          label: "Crowdfunding",
          href: "#",
        },
      ],
      [
        {
          label: "Marketing Advice",
          href: "#",
        },
        {
          label: "Search Engine Marketing (SEM)",
          href: "#",
        },
        {
          label: "Display Advertising",
          href: "#",
        },
        {
          label: "E-commerce Marketing",
          href: "#",
        },
        {
          label: "Influencer Marketing",
          href: "#",
        },
        {
          label: "Community Management",
          href: "#",
        },
        {
          label: "Mobile App Marketing",
          href: "#",
        },
        {
          label: "Music Promotion",
          href: "#",
        },
        {
          label: "Book & eBook Marketing",
          href: "#",
        },
        {
          label: "Podcast Marketing",
          href: "#",
        },
        {
          label: "Affiliate Marketing",
          href: "#",
        },
        {
          label: "Other",
          href: "#",
        },
      ],
    ],
  },
  {
    name: "Writing & Translation",
    structured: false,
    linksList: [
      [
        {
          label: "Articles & Blog Posts",
          href: "#",
        },
        {
          label: "Translation",
          href: "#",
        },
        {
          label: "Proofreading & Editing",
          href: "#",
        },
        {
          label: "Resume Writing",
          href: "#",
        },
        {
          label: "Cover Letters",
          href: "#",
        },
        {
          label: "LinkedIn Profiles",
          href: "#",
        },
        {
          label: "Ad Copy",
          href: "#",
        },
        {
          label: "Sales Copy",
          href: "#",
        },
        {
          label: "Social Media Copy",
          href: "#",
        },
        {
          label: "Email Copy",
          href: "#",
        },
        {
          label: "Case Studies",
          href: "#",
        },
      ],
      [
        {
          label: "Book & eBook Writing",
          href: "#",
        },
        {
          label: "Book Editing",
          href: "#",
        },
        {
          label: "Scriptwriting",
          href: "#",
        },
        {
          label: "Beta Reading",
          href: "#",
        },
        {
          label: "Creative Writing",
          href: "#",
        },
        {
          label: "Brand Voice & Tone",
          href: "#",
        },
        {
          label: "Speechwriting",
          href: "#",
        },
        {
          label: "eLearning Content ",
          href: "#",
        },
        {
          label: "Development",
          href: "#",
        },
        {
          label: "Technical Writing",
          href: "#",
        },
        {
          label: "UX Writing",
          href: "#",
        },
      ],
      [
        {
          label: "Articles & Blog Posts",
          href: "#",
        },
        {
          label: "Translation",
          href: "#",
        },
        {
          label: "Proofreading & Editing",
          href: "#",
        },
        {
          label: "Resume Writing",
          href: "#",
        },
        {
          label: "Cover Letters",
          href: "#",
        },
        {
          label: "LinkedIn Profiles",
          href: "#",
        },
        {
          label: "Ad Copy",
          href: "#",
        },
        {
          label: "Sales Copy",
          href: "#",
        },
        {
          label: "Social Media Copy",
          href: "#",
        },
        {
          label: "Email Copy",
          href: "#",
        },
        {
          label: "Case Studies",
          href: "#",
        },
      ],
    ],
  },
  {
    name: "Video & Animation",
    structured: false,
    linksList: [
      [
        {
          label: "Video Editing",
          href: "#",
        },
        {
          label: "Video Ads & Commercials",
          href: "#",
        },
        {
          label: "Animated Explainers",
          href: "#",
        },
        {
          label: "Character Animation",
          href: "#",
        },
        {
          label: "Music Videos",
          href: "#",
        },
        {
          label: "Logo Animation",
          href: "#",
        },
        {
          label: "Lottie & Web Animation",
          href: "#",
        },
        {
          label: "Intro & Outro Videos",
          href: "#",
        },
        {
          label: "Visual Effects",
          href: "#",
        },
        {
          label: "Rigging",
          href: "#",
        },
        {
          label: "Subtitles & Captions",
          href: "#",
        },
        {
          label: "App & Website Previews",
          href: "#",
        },
        {
          label: "3D Product Animation",
          href: "#",
        },
      ],
      [
        {
          label: "Social Media Videos",
          href: "#",
        },
        {
          label: "E-Commerce Product Videos",
          href: "#",
        },
        {
          label: "Spokesperson Videos",
          href: "#",
        },
        {
          label: "Animated GIFs",
          href: "#",
        },
        {
          label: "Unboxing Videos",
          href: "#",
        },
        {
          label: "Corporate Videos",
          href: "#",
        },
        {
          label: "Slideshow Videos",
          href: "#",
        },
        {
          label: "Crowdfunding Videos ",
          href: "#",
        },
        {
          label: "Meditation Videos",
          href: "#",
        },
        {
          label: "Videographers",
          href: "#",
        },
        {
          label: "Filmed Video Production",
          href: "#",
        },
        {
          label: "Live Action Explainers",
          href: "#",
        },
        {
          label: "Game Trailers",
          href: "#",
        },
      ],
      [
        {
          label: "Book Trailers",
          href: "#",
        },
        {
          label: "NFT Animation",
          href: "#",
        },
        {
          label: "Animation for Streamers ",
          href: "#",
        },
        {
          label: "Animation for Kids",
          href: "#",
        },
        {
          label: "Article to Video",
          href: "#",
        },
        {
          label: "Real Estate Promos",
          href: "#",
        },
        {
          label: "eLearning Video Production",
          href: "#",
        },
        {
          label: "Video Templates Editing",
          href: "#",
        },
        {
          label: "Screencasting Videos",
          href: "#",
        },
        {
          label: "Video Advice",
          href: "#",
        },
      ],
    ],
  },
  {
    name: "Music & Audio",
    structured: false,
    linksList: [
      [
        {
          label: "Video Editing",
          href: "#",
        },
        {
          label: "Video Ads & Commercials",
          href: "#",
        },
        {
          label: "Animated Explainers",
          href: "#",
        },
        {
          label: "Character Animation",
          href: "#",
        },
        {
          label: "Music Videos",
          href: "#",
        },
        {
          label: "Logo Animation",
          href: "#",
        },
        {
          label: "Lottie & Web Animation",
          href: "#",
        },
        {
          label: "Intro & Outro Videos",
          href: "#",
        },
        {
          label: "Visual Effects",
          href: "#",
        },
        {
          label: "Rigging",
          href: "#",
        },
        {
          label: "Subtitles & Captions",
          href: "#",
        },
        {
          label: "App & Website Previews",
          href: "#",
        },
        {
          label: "3D Product Animation",
          href: "#",
        },
      ],
      [
        {
          label: "Social Media Videos",
          href: "#",
        },
        {
          label: "E-Commerce Product Videos",
          href: "#",
        },
        {
          label: "Spokesperson Videos",
          href: "#",
        },
        {
          label: "Animated GIFs",
          href: "#",
        },
        {
          label: "Unboxing Videos",
          href: "#",
        },
        {
          label: "Corporate Videos",
          href: "#",
        },
        {
          label: "Slideshow Videos",
          href: "#",
        },
        {
          label: "Crowdfunding Videos ",
          href: "#",
        },
        {
          label: "Meditation Videos",
          href: "#",
        },
        {
          label: "Videographers",
          href: "#",
        },
        {
          label: "Filmed Video Production",
          href: "#",
        },
        {
          label: "Live Action Explainers",
          href: "#",
        },
        {
          label: "Game Trailers",
          href: "#",
        },
      ],
      [
        {
          label: "Book Trailers",
          href: "#",
        },
        {
          label: "NFT Animation",
          href: "#",
        },
        {
          label: "Animation for Streamers ",
          href: "#",
        },
        {
          label: "Animation for Kids",
          href: "#",
        },
        {
          label: "Article to Video",
          href: "#",
        },
        {
          label: "Real Estate Promos",
          href: "#",
        },
        {
          label: "eLearning Video Production",
          href: "#",
        },
        {
          label: "Video Templates Editing",
          href: "#",
        },
        {
          label: "Screencasting Videos",
          href: "#",
        },
        {
          label: "Video Advice",
          href: "#",
        },
      ],
    ],
  },
  {
    name: "Programming & Tech",
    structured: false,
    linksList: [
      [
        {
          label: "Video Editing",
          href: "#",
        },
        {
          label: "Video Ads & Commercials",
          href: "#",
        },
        {
          label: "Animated Explainers",
          href: "#",
        },
        {
          label: "Character Animation",
          href: "#",
        },
        {
          label: "Music Videos",
          href: "#",
        },
        {
          label: "Logo Animation",
          href: "#",
        },
        {
          label: "Lottie & Web Animation",
          href: "#",
        },
        {
          label: "Intro & Outro Videos",
          href: "#",
        },
        {
          label: "Visual Effects",
          href: "#",
        },
        {
          label: "Rigging",
          href: "#",
        },
        {
          label: "Subtitles & Captions",
          href: "#",
        },
        {
          label: "App & Website Previews",
          href: "#",
        },
        {
          label: "3D Product Animation",
          href: "#",
        },
      ],
      [
        {
          label: "Social Media Videos",
          href: "#",
        },
        {
          label: "E-Commerce Product Videos",
          href: "#",
        },
        {
          label: "Spokesperson Videos",
          href: "#",
        },
        {
          label: "Animated GIFs",
          href: "#",
        },
        {
          label: "Unboxing Videos",
          href: "#",
        },
        {
          label: "Corporate Videos",
          href: "#",
        },
        {
          label: "Slideshow Videos",
          href: "#",
        },
        {
          label: "Crowdfunding Videos ",
          href: "#",
        },
        {
          label: "Meditation Videos",
          href: "#",
        },
        {
          label: "Videographers",
          href: "#",
        },
        {
          label: "Filmed Video Production",
          href: "#",
        },
        {
          label: "Live Action Explainers",
          href: "#",
        },
        {
          label: "Game Trailers",
          href: "#",
        },
      ],
      [
        {
          label: "Book Trailers",
          href: "#",
        },
        {
          label: "NFT Animation",
          href: "#",
        },
        {
          label: "Animation for Streamers ",
          href: "#",
        },
        {
          label: "Animation for Kids",
          href: "#",
        },
        {
          label: "Article to Video",
          href: "#",
        },
        {
          label: "Real Estate Promos",
          href: "#",
        },
        {
          label: "eLearning Video Production",
          href: "#",
        },
        {
          label: "Video Templates Editing",
          href: "#",
        },
        {
          label: "Screencasting Videos",
          href: "#",
        },
        {
          label: "Video Advice",
          href: "#",
        },
      ],
    ],
  },
  {
    name: "Business",
    structured: false,
    linksList: [
      [
        {
          label: "Video Editing",
          href: "#",
        },
        {
          label: "Video Ads & Commercials",
          href: "#",
        },
        {
          label: "Animated Explainers",
          href: "#",
        },
        {
          label: "Character Animation",
          href: "#",
        },
        {
          label: "Music Videos",
          href: "#",
        },
        {
          label: "Logo Animation",
          href: "#",
        },
        {
          label: "Lottie & Web Animation",
          href: "#",
        },
        {
          label: "Intro & Outro Videos",
          href: "#",
        },
        {
          label: "Visual Effects",
          href: "#",
        },
        {
          label: "Rigging",
          href: "#",
        },
        {
          label: "Subtitles & Captions",
          href: "#",
        },
        {
          label: "App & Website Previews",
          href: "#",
        },
        {
          label: "3D Product Animation",
          href: "#",
        },
      ],
      [
        {
          label: "Social Media Videos",
          href: "#",
        },
        {
          label: "E-Commerce Product Videos",
          href: "#",
        },
        {
          label: "Spokesperson Videos",
          href: "#",
        },
        {
          label: "Animated GIFs",
          href: "#",
        },
        {
          label: "Unboxing Videos",
          href: "#",
        },
        {
          label: "Corporate Videos",
          href: "#",
        },
        {
          label: "Slideshow Videos",
          href: "#",
        },
        {
          label: "Crowdfunding Videos ",
          href: "#",
        },
        {
          label: "Meditation Videos",
          href: "#",
        },
        {
          label: "Videographers",
          href: "#",
        },
        {
          label: "Filmed Video Production",
          href: "#",
        },
        {
          label: "Live Action Explainers",
          href: "#",
        },
        {
          label: "Game Trailers",
          href: "#",
        },
      ],
      [
        {
          label: "Book Trailers",
          href: "#",
        },
        {
          label: "NFT Animation",
          href: "#",
        },
        {
          label: "Animation for Streamers ",
          href: "#",
        },
        {
          label: "Animation for Kids",
          href: "#",
        },
        {
          label: "Article to Video",
          href: "#",
        },
        {
          label: "Real Estate Promos",
          href: "#",
        },
        {
          label: "eLearning Video Production",
          href: "#",
        },
        {
          label: "Video Templates Editing",
          href: "#",
        },
        {
          label: "Screencasting Videos",
          href: "#",
        },
        {
          label: "Video Advice",
          href: "#",
        },
      ],
    ],
  },
  {
    name: "Lifestyle",
    structured: false,
    linksList: [
      [
        {
          label: "Video Editing",
          href: "#",
        },
        {
          label: "Video Ads & Commercials",
          href: "#",
        },
        {
          label: "Animated Explainers",
          href: "#",
        },
        {
          label: "Character Animation",
          href: "#",
        },
        {
          label: "Music Videos",
          href: "#",
        },
        {
          label: "Logo Animation",
          href: "#",
        },
        {
          label: "Lottie & Web Animation",
          href: "#",
        },
        {
          label: "Intro & Outro Videos",
          href: "#",
        },
        {
          label: "Visual Effects",
          href: "#",
        },
        {
          label: "Rigging",
          href: "#",
        },
        {
          label: "Subtitles & Captions",
          href: "#",
        },
        {
          label: "App & Website Previews",
          href: "#",
        },
        {
          label: "3D Product Animation",
          href: "#",
        },
      ],
      [
        {
          label: "Social Media Videos",
          href: "#",
        },
        {
          label: "E-Commerce Product Videos",
          href: "#",
        },
        {
          label: "Spokesperson Videos",
          href: "#",
        },
        {
          label: "Animated GIFs",
          href: "#",
        },
        {
          label: "Unboxing Videos",
          href: "#",
        },
        {
          label: "Corporate Videos",
          href: "#",
        },
        {
          label: "Slideshow Videos",
          href: "#",
        },
        {
          label: "Crowdfunding Videos ",
          href: "#",
        },
        {
          label: "Meditation Videos",
          href: "#",
        },
        {
          label: "Videographers",
          href: "#",
        },
        {
          label: "Filmed Video Production",
          href: "#",
        },
        {
          label: "Live Action Explainers",
          href: "#",
        },
        {
          label: "Game Trailers",
          href: "#",
        },
      ],
      [
        {
          label: "Book Trailers",
          href: "#",
        },
        {
          label: "NFT Animation",
          href: "#",
        },
        {
          label: "Animation for Streamers ",
          href: "#",
        },
        {
          label: "Animation for Kids",
          href: "#",
        },
        {
          label: "Article to Video",
          href: "#",
        },
        {
          label: "Real Estate Promos",
          href: "#",
        },
        {
          label: "eLearning Video Production",
          href: "#",
        },
        {
          label: "Video Templates Editing",
          href: "#",
        },
        {
          label: "Screencasting Videos",
          href: "#",
        },
        {
          label: "Video Advice",
          href: "#",
        },
      ],
    ],
  },
  {
    name: "Trending",
    structured: false,
    linksList: [
      [
        {
          label: "Video Editing",
          href: "#",
        },
        {
          label: "Video Ads & Commercials",
          href: "#",
        },
        {
          label: "Animated Explainers",
          href: "#",
        },
        {
          label: "Character Animation",
          href: "#",
        },
        {
          label: "Music Videos",
          href: "#",
        },
        {
          label: "Logo Animation",
          href: "#",
        },
        {
          label: "Lottie & Web Animation",
          href: "#",
        },
        {
          label: "Intro & Outro Videos",
          href: "#",
        },
        {
          label: "Visual Effects",
          href: "#",
        },
        {
          label: "Rigging",
          href: "#",
        },
        {
          label: "Subtitles & Captions",
          href: "#",
        },
        {
          label: "App & Website Previews",
          href: "#",
        },
        {
          label: "3D Product Animation",
          href: "#",
        },
      ],
      [
        {
          label: "Social Media Videos",
          href: "#",
        },
        {
          label: "E-Commerce Product Videos",
          href: "#",
        },
        {
          label: "Spokesperson Videos",
          href: "#",
        },
        {
          label: "Animated GIFs",
          href: "#",
        },
        {
          label: "Unboxing Videos",
          href: "#",
        },
        {
          label: "Corporate Videos",
          href: "#",
        },
        {
          label: "Slideshow Videos",
          href: "#",
        },
        {
          label: "Crowdfunding Videos ",
          href: "#",
        },
        {
          label: "Meditation Videos",
          href: "#",
        },
        {
          label: "Videographers",
          href: "#",
        },
        {
          label: "Filmed Video Production",
          href: "#",
        },
        {
          label: "Live Action Explainers",
          href: "#",
        },
        {
          label: "Game Trailers",
          href: "#",
        },
      ],
      [
        {
          label: "Book Trailers",
          href: "#",
        },
        {
          label: "NFT Animation",
          href: "#",
        },
        {
          label: "Animation for Streamers ",
          href: "#",
        },
        {
          label: "Animation for Kids",
          href: "#",
        },
        {
          label: "Article to Video",
          href: "#",
        },
        {
          label: "Real Estate Promos",
          href: "#",
        },
        {
          label: "eLearning Video Production",
          href: "#",
        },
        {
          label: "Video Templates Editing",
          href: "#",
        },
        {
          label: "Screencasting Videos",
          href: "#",
        },
        {
          label: "Video Advice",
          href: "#",
        },
      ],
    ],
  },
];
